import { Link, Typography } from "@mui/material";
import { Links, SystemStatus } from "src/constants";
import { FeedItemDto } from "src/http";

interface Props {
  feedItem: FeedItemDto;
}

const RoleNamePropertyChange = (props: Props) => {
  if (props.feedItem.propertyChange?.changeType === SystemStatus.Created) {
    return (
      <Typography variant="caption">
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> created role </span>
        <strong>{props.feedItem.propertyChange!.value}</strong>
      </Typography>
    );
  }

  return (
    <Typography variant="caption">
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span> updated name to </span>
      <strong>{props.feedItem.propertyChange!.value}</strong>
    </Typography>
  );
};

export { RoleNamePropertyChange };
